namespace TabAurous.Retail {
    export interface POSReturnItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        ProductCode?: string;
        ProductName?: string;
        TaxCode?: string;
        DesignId?: number;
        DesignCode?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        CollectionId?: number;
        AttributeId?: number;
        StampId?: number;
        HSN?: string;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CostMethodId?: number;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        CalcOnId?: number;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        VoucherNo?: string;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        MF?: number;
        MFAmount?: number;
        BOMDetails?: POSReturnItemsBOMRow[];
        LaborDetails?: POSReturnLaborRow[];
        HasBom?: boolean;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        StockAllocation?: boolean;
        SieveId?: number;
        GroupSieveId?: number;
        Rate?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        KaratId?: number;
        ProductSizeId?: number;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        MetalId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        StoneRate?: number;
        OtherRate?: number;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        FancyCharges?: number;
        OtherCharges?: number;
        HUID?: string;
        ExportPieces?: number;
    }

    export namespace POSReturnItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Retail.POSReturnItems';
        export const deletePermission = 'Retail:POSReturn:Delete';
        export const insertPermission = 'Retail:POSReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSReturn:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            TaxCode = "TaxCode",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            CollectionId = "CollectionId",
            AttributeId = "AttributeId",
            StampId = "StampId",
            HSN = "HSN",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            CalcOnId = "CalcOnId",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            VoucherNo = "VoucherNo",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            MF = "MF",
            MFAmount = "MFAmount",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            HasBom = "HasBom",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            StockAllocation = "StockAllocation",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            Rate = "Rate",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            MetalId = "MetalId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            HUID = "HUID",
            ExportPieces = "ExportPieces"
        }
    }
}
